module.exports = __webpack_public_path__ + "media/images/member-database-3-6b55744eb734855eb65363dff295e99f.svg";